const TF_SHIFT = 12
const TOTFREQ = 1 << TF_SHIFT
const RANS_BYTE_L = 1 << 23

export { TF_SHIFT, TOTFREQ, RANS_BYTE_L }
